import React, { useState } from "react";
import experience from "../data/experience.json";
import "../styles/Experience.css";

const newestFirst = experience;
const roleKey = role => `${role.company}-${role.title}`;

const Experience = () => {
  const [selectedRoleKey, setSelectedRoleKey] = useState(roleKey(newestFirst[0]));
  const selectedRole = newestFirst.find(role => roleKey(role) === selectedRoleKey);
  const selectedIndex = newestFirst.findIndex(role => roleKey(role) === selectedRoleKey);
  const progress = newestFirst.length > 1 ? (selectedIndex / (newestFirst.length - 1)) * 100 : 0;

  const selectRelativeRole = offset => {
    const nextIndex = Math.max(0, Math.min(newestFirst.length - 1, selectedIndex + offset));
    setSelectedRoleKey(roleKey(newestFirst[nextIndex]));
  };

  const handleTimelineKeyDown = (event, index) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    event.preventDefault();
    const nextIndex = Math.max(0, Math.min(newestFirst.length - 1, index + (event.key === "ArrowRight" ? 1 : -1)));
    const nextRole = newestFirst[nextIndex];
    setSelectedRoleKey(roleKey(nextRole));
    document.querySelector(`[data-experience-role="${CSS.escape(roleKey(nextRole))}"]`)?.focus();
  };

  return (
    <section id="experience" className="site-section">
      <div className="section-header">
        <span className="section-title experience-title">Experience</span>
      </div>

      <div className="experience-desktop-timeline">
        <div className="experience-timeline-track" style={{ "--timeline-progress": progress / 100 }}>
          {newestFirst.map((role, index) => {
            const isSelected = roleKey(role) === selectedRoleKey;
            const isCurrent = roleKey(role) === roleKey(newestFirst[0]);
            return (
              <div className="experience-timeline-stop" key={roleKey(role)}>
                <span className="experience-timeline-label">
                  <span className="experience-timeline-title">{role.title}</span>
                  <span className="experience-timeline-company">{role.company}</span>
                </span>
                <button
                  type="button"
                  className={`experience-timeline-dot${isSelected ? " selected" : ""}${isCurrent ? " current" : ""}`}
                  data-experience-role={roleKey(role)}
                  aria-label={`Select ${role.title} at ${role.company}, ${role.dates}`}
                  aria-pressed={isSelected}
                  onClick={() => setSelectedRoleKey(roleKey(role))}
                  onMouseEnter={() => setSelectedRoleKey(roleKey(role))}
                  onKeyDown={event => handleTimelineKeyDown(event, index)}
                />
                <time className="experience-timeline-date">{role.dates}</time>
              </div>
            );
          })}
        </div>

        {selectedRole && (
          <div className="experience-detail-row">
            <button
              type="button"
              className="experience-step-button"
              aria-label="Newer role"
              disabled={selectedIndex === 0}
              onClick={() => selectRelativeRole(-1)}
            >
              ←
            </button>
            <article className="experience-detail-card" key={selectedRoleKey} aria-live="polite">
              <div className="experience-detail-heading">
                <div>
                  <h3>{selectedRole.title}</h3>
                  <span className="experience-detail-company">{selectedRole.company}</span>
                </div>
                <time className="experience-detail-date">{selectedRole.dates}</time>
              </div>
              <p>{selectedRole.bullet}</p>
            </article>
            <button
              type="button"
              className="experience-step-button"
              aria-label="Older role"
              disabled={selectedIndex === newestFirst.length - 1}
              onClick={() => selectRelativeRole(1)}
            >
              →
            </button>
          </div>
        )}
      </div>

      <div className="experience-mobile-timeline">
        {newestFirst.map(role => (
          <article className="experience-mobile-role" key={roleKey(role)}>
            <div className="experience-mobile-marker" aria-hidden="true" />
            <div className="experience-mobile-content">
              <h3>{role.title}</h3>
              <span className="experience-detail-company">{role.company}</span>
              <time className="experience-detail-date">{role.dates}</time>
              <p>{role.bullet}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Experience;